export default class ProjectListTableItem {
    projectId: number = null;
    projectStatus: number = null;
    orgCode: number = null;
    projectYeahId: number = null;
    projectTypeId: number = null;
    projectCraftsId: number = null;
    projectOptModeId: number = null;
    projectLayerId: number = null;
    projectProductionId: number = null;
    projectImplementId: number = null;
    projectInformationId: number = null;
    projectIntegrationId: number = null;
    serialNumber = "";
    cockpitCode = "";
    assetCode = "";
    projectCode = "";
    projectName = "";
    projectSourceId: number = null;
    projectWarranty: number = null;
    acceptanceTime = "";
    hardwareExpireTime = "";
    serviceExpireTime = "";
    projectRemark = "";

    orgCodeName = "";
    orgAddress = "";
    projectYeahIdName = "";
    projectTypeIdName = "";
    projectCraftsIdName = "";
    projectOptModeIdName = "";
    projectLayerIdName = "";
    projectMachineIdName = "";
    projectInformationIdName = "";
    projectIntegrationIdName = "";
    projectSourceIdName = "";
    projectWarrantyName = "";

    createTime = "";
    createName = "";
    modifyTime = "";
    modifyName = "";
}
